export class OfficeTypeModel{
    id:number;
    nameBn:string;
    nameEn:string;
    code:string;
    parentId:number;
    catchmentType:number;
}